import { PropertiesPanel } from '../../../../../../widgets/propertiesPanel';
import React, { FC, useMemo } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { CameraConfigHelpers, CameraNode, CameraProperty, useCameraPropertiesCreator } from '../cameraEditorConfig';

// Global styles for camera overlay properties panel inputs
const OverlayInputStyles = createGlobalStyle`
	.camera-overlay-properties input[type="number"] {
		width: 80px !important;
	}
	
	.camera-overlay-properties input[type="text"] {
		width: 80px !important;
	}
	
	/* Escludiamo esplicitamente le checkbox e altri tipi di input */
	.camera-overlay-properties input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]) {
		width: 80px !important;
	}
`;

const CameraSettingsOverlayComponentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px;
    border-radius: 8px;
    width: 100%;
`;

const PropertiesPanelContainer = styled.div`
    width: 100%;
`;

export interface CameraOverlayProps {
    camera: {
        id: string;
        name: string;
        position: [number, number, number];
        target: [number, number, number];
        fov: number;
        isActive: boolean;
        enableZoomLimit: boolean;
        enableHorizontalLimit: boolean;
        enableVerticalLimit: boolean;
        // Proprietà zoom
        useMinZoomPerc: boolean;
        useMaxZoomPerc: boolean;
        minZoomPerc: number;
        maxZoomPerc: number;
        // Proprietà rotazione
        lowerBetaLimits: number | undefined;
        upperBetaLimits: number | undefined;
        lowerAlphaLimit: number | undefined;
        upperAlphaLimit: number | undefined;
        height: number;
    };
    onPropertyChange: (property: CameraProperty, value?: any) => void;
}

const CameraSettingOverlayComponent: FC<CameraOverlayProps> = ({ camera, onPropertyChange }) => {
    // Hook per creare le proprietà della camera
    const createCameraProperties = useCameraPropertiesCreator();

    // Crea gli helpers per la configurazione delle proprietà
    const helpers: CameraConfigHelpers = useMemo(
        () => ({
            onPropertyChange
        }),
        [onPropertyChange]
    );

    // Genera le proprietà usando il factory pattern
    const properties = useMemo(() => {
        return createCameraProperties(camera as CameraNode, helpers);
    }, [createCameraProperties, camera, helpers]);

    return (
        <>
            <OverlayInputStyles />
            <CameraSettingsOverlayComponentContainer>
                <PropertiesPanelContainer className='camera-overlay-properties'>
                    <PropertiesPanel properties={properties} />
                </PropertiesPanelContainer>
            </CameraSettingsOverlayComponentContainer>
        </>
    );
};

export default CameraSettingOverlayComponent;
